module.exports = __webpack_public_path__ + "static/media/90.4e2b7a33.svg";